export const getFieldDescriptionType = <T extends { description?: string; htmlDescription?: string }>({
  description,
  htmlDescription,
}: T): "htmlDescription" | "description" | undefined => {
  if (
    htmlDescription?.startsWith("<!-- DO NOT DELETE THIS COMMENT, USING CUSTOM TELLESCOPE_HTML -->") ||
    (!!htmlDescription && !description)
  )
    return "htmlDescription";
  if (description) return "description";
  return undefined;
};
